import React from 'react';
import { X } from 'lucide-react';

export const DetailPanel: React.FC<{
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
}> = ({ open, onClose, title, children }) => {
  if (!open) return null;
  return (
    <div className="bg-[#161b22] border border-white/10 rounded-xl p-5 mt-4 animate-in slide-in-from-top-2">
      <div className="flex justify-end mb-2">
        <button onClick={onClose} className="p-1 text-gray-500 hover:text-gray-300 transition-colors">
          <X size={16} />
        </button>
      </div>
      {children}
    </div>
  );
};
